// Generated sandbox code: SSVMN - PlusTools - Editor v6.4.1 - 02/12/2020
// Created/Updated by Developer - 7/16/2021

import { Component } from '@angular/core'
import { ADN_PLUS, CtColumnComponent, CtInputDateComponent, CtInputFileComponent, CtInputTextComponent, CtLabelComponent, CtRowComponent, CtTabComponent, CtTableComponent, HttpService } from 'components';
import { BaseController } from './base.controller';

@Component({
	selector: 'av-vi03',
	template: `<div [id]="getId()" #target><div>`
})

export class AvVi03 extends BaseController {

	constructor() {
		super();
		super.setViewCode('AV_VI03');
	}

	/* ---------------------- CONTROLLER LOGIC ------------------- */

	getUserTransHistory(e, r) {

		let inputText = this.utilService.getComponentRef(e.actionParams[0]) as CtInputTextComponent;
		let inputDate = this.utilService.getComponentRef(e.actionParams[1]) as CtInputDateComponent;

		let contRequest = {
			"Type": 1,
			"UserCode": "SVA",
			"Source": "SVA",
			"Conditions":
			{
				"Data": [
					{
						"Name": "NUM_CLIENTE",
						"Alias": "NUM_CLIENTE",
						"Value": this.loggedUser.user.num_cliente_sigma,
						"Display": "",
						"Type": 1,
						"FamilyId": ""
					},
					{
						"Name": "NUM_SOL",
						"Alias": "NUM_SOL",
						"Value": inputText.getValue(),
						"Display": "",
						"Type": 1,
						"FamilyId": ""
					},
					{
						"Name": "FEC_HASTA",
						"Alias": "FEC_HASTA",
						"Value": inputDate.getValue(),
						"Display": "",
						"Type": 1,
						"FamilyId": ""
					}
				]
			},
			"Data": []
		}

		return this.httpService.post(HttpService.ENDPOINT + '/api/process/PRE_SOLICITUD_CRED/SER_GET_USER_TRANSACTIONS', contRequest)

	}

	bindSelectedItem(e, r) {
		let table = this.utilService.getComponentRef(e.actionParams[0]) as CtTableComponent;
		let adn = table.getSelectedAdn();
		for (let i = 1; i < e.actionParams.length; i++) {
			const element = this.utilService.getComponentRef(e.actionParams[i]) as CtLabelComponent;
			const value = adn.getStringAttribute(element.getModelId());
			element.setLabelValue(value || "");
		}
	}

	hideOrShowUpload(e, r) {
		let row = this.utilService.getComponentRef(e.actionParams[0]) as CtRowComponent;
		let table = this.utilService.getComponentRef(e.actionParams[1]) as CtTableComponent;

		row.setHidden(!(table.getSelectedAdn()?.getStringAttribute('ESTADO_SOLIC') == 'DP'));

	}

	uploadFiles(e, r) {
		let inputFile = this.utilService.getComponentRef(e.actionParams[0]) as CtInputFileComponent;
		let table = this.utilService.getComponentRef(e.actionParams[1]) as CtTableComponent;
		let adn = table.getSelectedAdn();
		let files = [...inputFile.getProcessedFiles()];
		if (files.length <= 0) {
			throw new Error("Debe seleccionar al menos un archivo.");
		}

		let contRequest = {
			"Type": 1,
			"UserCode": "SVA",
			"Source": "SVA",
			"Conditions":
			{
				"Data": [
					{
						"Name": "DOC_IDENTIFICACION",
						"Alias": "DOC_IDENTIFICACION",
						"Value": this.loggedUser.user.user_code,
						"Display": "",
						"Type": 1,
						"FamilyId": ""
					},
					{
						"Name": "NUM_SOL",
						"Alias": "NUM_SOL",
						"Value": adn.getStringAttribute('NUM_SOL'),
						"Display": "",
						"Type": 1,
						"FamilyId": ""
					}
				]
			},
			"Data": [],
			"Files": files
		}

		return this.httpService.post(HttpService.ENDPOINT + '/api/process/PRE_SOLICITUD_CRED/SER_UPLOAD_DOCS_PRESOL', contRequest)
	}

	/* -------------------- END CONTROLLER LOGIC ----------------- */

}